<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div ref="chartContainer" style="width: 100%; height: 600px;" />
      </el-card>
    </template>
  </BasicLayout>

</template>

<script>
import echarts from 'echarts'

export default {
  name: 'UserStat',
  props: {
    rate: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '人数'
    },
    k: {
      type: String,
      default: 'spin'
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      this.option = {
        color: ['red', '#00BFFF', '#FFA500'],
        title: {
          text: this.title
        },
        xAxis: {
          name: '日期',
          type: 'category',
          data: []
        },
        legend: {
          data: ['人数', '占比'],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          }
        }, {
          type: 'value',
          axisLabel: {
            formatter: '{value}%' // 使用默认的数值格式
          }
        }],
        toolbox: {
          show: true,
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(data, rangeTitle) {
      this.initChart()
      const time = []
      const cdata = []
      const udata = []
      if (data.length <= 0) {
        this.option.series = []
        this.chart.setOption(this.option, true)
        return
      }
      for (const i in rangeTitle) {
        const val = rangeTitle[i]
        time.push(val)
      }

      for (const i in data) {
        cdata.push(data[i].rate)
        udata.push(data[i].user)
      }
      const temp = {
        name: '占比',
        data: cdata,
        type: 'line',
        yAxisIndex: 1,
        smooth: true,
        label: {
          show: true,
          position: 'top', // 标签显示在折线图顶部
          formatter: '{c}' // 显示数值
        }
      }
      const temp2 = {
        name: '人数',
        data: udata,
        type: 'bar',
        smooth: true,
        yAxisIndex: 0,
        label: {
          show: true,
          position: 'top', // 标签显示在折线图顶部
          formatter: '{c}' // 显示数值
        }
      }
      this.option.series.push(temp)
      this.option.series.push(temp2)
      this.option.legend.data = time
      this.option.xAxis.data = time
      this.chart.setOption(this.option, true)
    }
  }

}
</script>

<style scoped>

</style>
